module.exports = __webpack_public_path__ + "static/media/ps-no_problem_machines.ed807206.png";